import React from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import perksNearMe from "@irati/ui/images/perks-near-me.svg";
import { geolocationTracking } from "@irati-tracking/geolocation";
import { RouterLink } from "@irati/ui/src/Link";
import Flex from "@irati/ui/src/Flex";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import { Body, H3 } from "@irati/ui/src/Typography";
import { FlexContainer, ImageWrapper, Image } from "./styled";
var PerksNearMeCTA = function (props, _a) {
    var apps = _a.apps;
    var routerLinkUrl = "/perks/location";
    var userLocation = props.userLocation, headerText = props.headerText, bodyText = props.bodyText, id = props.id;
    var handleButtonClick = function () {
        geolocationTracking.clickPerksHomepagePerksNearMeCTA(userLocation.city);
    };
    return (React.createElement(FlexContainer, { id: id },
        React.createElement(ImageWrapper, null,
            React.createElement(Image, { src: perksNearMe }),
            React.createElement("div", null,
                React.createElement(H3, { paddingBottom: 1 }, headerText),
                React.createElement(Body, { small: true, width: "80%" }, bodyText))),
        React.createElement(RouterLink, { cta: true, to: routerLinkUrl, app: apps.SEARCH, onClick: handleButtonClick },
            React.createElement(Flex, { alignItems: "center" },
                React.createElement(FormattedMessage, { id: "perks.perksNearMeCTA.button.text" }),
                React.createElement(Icon, { icon: IconTypes.arrowRight, marginLeft: true })))));
};
export default React.memo(injectIntl(PerksNearMeCTA));
PerksNearMeCTA.contextTypes = {
    apps: PropTypes.object.isRequired
};
